export default "__VITE_ASSET__66e6ea80__"